
import StrategyCard from "@/pages/pricing/components/StrategyCard";

const ComparisonTable = () => (
  <div className="grid md:grid-cols-2 gap-8 mb-12">
    <StrategyCard type="free" />
    <StrategyCard type="premium" />
  </div>
);

export default ComparisonTable;
